import { type EventName } from "./events";
import { Telemetry } from "./telemetry";

export { ReviewView } from "./events";

interface GetTelemetryImplementationOptions {
  appName: "chainpatrol-web";
  posthogApiKey?: string;
}

export function getTelemetryImplementation(options: GetTelemetryImplementationOptions) {
  return new Telemetry({
    appName: options.appName,
    posthogApiKey: options.posthogApiKey ?? "",
  });
}

export { type EventName };
